/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BilletOrderItemResponseViewModel } from "../types/BilletOrderItemResponseViewModel.ts";

export const billetOrderItemResponseViewModelSchema = z.object({
  quantity: z.optional(z.number().int()),
  description: z.string().nullish(),
  value: z.optional(z.number()),
  percentageDiscount: z.number().nullish(),
  currency: z.string().nullish(),
}) as unknown as ToZod<BilletOrderItemResponseViewModel>;
